/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import {
    fork, takeEvery, call, put, select,
} from 'redux-saga/effects';
import mbpLogger from 'mbp-logger';
import orderClient from '../../../../../../../apis/checkout-apis/orderClient';

import * as rewardPointsActions from './RewardPoints-Actions';
import memberDucks from '../../../../../Member/ducks';
import * as commonSelectors from '../../../Common/Common-Selectors';
import { showLoadingMessageActions } from '../../../Common/ducks/ShowLoadingMessage';

const {
    auth: {
        authOperations,
    },
} = memberDucks;
const { checkJWT } = authOperations.workers;

const getRewardElegilibity = ({
    jwtToken,
    orderId,
    creditCard,
    isCardTokenized,
    sourceApp,
}) => orderClient.rewardElegilibity(
    {},
    jwtToken,
    orderId,
    creditCard,
    isCardTokenized,
    sourceApp,
);

const getRewardBalance = ({
    jwtToken,
    orderId,
    creditCard,
    rewardAction,
    isCardTokenized,
    sourceApp,
}) => orderClient.rewardBalance(
    {},
    jwtToken,
    orderId,
    creditCard,
    rewardAction,
    isCardTokenized,
    sourceApp,
);

const removeMaskForAccountNumber = (number) => {
    const strAccountNumber = number.toString();
    if (strAccountNumber.indexOf('-') >= 0) {
        return strAccountNumber.split('-').join('');
    }
    return strAccountNumber;
};

function* loadRewardEligibility() {
    try {
        const paymentData =  yield select(commonSelectors.getPaymentInfo);
        if (paymentData && paymentData.accountNumber) {
            yield put(rewardPointsActions.clearAllRewardPoints());

            const jwtToken = yield call(checkJWT);
            const orderId = yield select(commonSelectors.getOrderId);

            const configObj = {
                jwtToken,
                orderId,
                creditCard: removeMaskForAccountNumber(paymentData.accountNumber),
                isCardTokenized: (paymentData?.isFromWallet),
                sourceApp: '', // This is not needed for PWA App
            };

            const responseRE = yield call(getRewardElegilibity, configObj);
            if (responseRE.status === 200) {
                yield put(rewardPointsActions.setRewardEligibility(responseRE.data));
            }
        }
    } catch (ex) {
        mbpLogger.logError({
            module: 'mbp-pwa-ui',
            function: 'loadRewardEligibility',
            message: 'Failed finding eligibility',
        });
    }
}

function* loadRewardEligibilityWatcher() {
    yield takeEvery(rewardPointsActions.loadRewardEligibility().type, loadRewardEligibility);
}

function* loadRewardPoints() {
    try {
        const paymentData =  yield select(commonSelectors.getPaymentInfo);
        const rewardPoints = yield select(commonSelectors.getRewardPointsInfo);

        if (
            paymentData?.accountNumber
            && (rewardPoints?.eligibility === 'Y' || rewardPoints?.eligibility === 'E')
        ) {
            yield put(showLoadingMessageActions.updateShowLoadingMessage());

            let rewardAction = 'ENABLE-REWARDS';
            if (rewardPoints?.eligibility === 'Y') {
                rewardAction = 'SHOW-REWARDS';
            }

            const jwtToken = yield call(checkJWT);
            const orderId = yield select(commonSelectors.getOrderId);

            const configObj = {
                jwtToken,
                orderId,
                creditCard: removeMaskForAccountNumber(paymentData.accountNumber),
                rewardAction,
                isCardTokenized: (paymentData?.isFromWallet),
                sourceApp: '', // This is not needed for PWA App
            };
            const responseRB = yield call(getRewardBalance, configObj);

            if (responseRB.status === 200) {
                let dataBalance = responseRB.data;

                // If the object come empty throw an error
                if (!dataBalance || Object.keys(dataBalance).length === 0) {
                    dataBalance = { error: true };
                    mbpLogger.logError({
                        responseBalance: responseRB,
                        module: 'mbp-pwa-ui',
                        function: 'loadRewardPoints',
                        message: 'Failed finding reward points balance',
                    });
                }

                yield put(rewardPointsActions.setRewardPoints(dataBalance));
            }

            yield put(showLoadingMessageActions.flagOffShowLoadingMessage());
        }
    } catch (ex) {
        mbpLogger.logError({
            module: 'mbp-pwa-ui',
            function: 'loadRewardPoints',
            message: 'Failed finding reward points balance',
        });

        yield put(showLoadingMessageActions.flagOffShowLoadingMessage());
    }
}

function* loadRewardPointsWatcher() {
    yield takeEvery(rewardPointsActions.loadRewardPoints().type, loadRewardPoints);
}

const watchers = [
    fork(loadRewardPointsWatcher),
    fork(loadRewardEligibilityWatcher),
];

export { watchers };

export default {};
